import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

const getInitial = () => {
  if (typeof window === 'undefined') return true;
  return window.matchMedia?.(QUERY).matches === true;
};

/**
 * Tracks the user's motion preference and keeps up with changes to it.
 *
 * Distinct from useReveal's internal check, which also treats a missing
 * IntersectionObserver as "skip" - here we only care about the preference.
 */
const usePrefersReducedMotion = () => {
  const [prefersReduced, setPrefersReduced] = useState(getInitial);

  useEffect(() => {
    const mql = window.matchMedia?.(QUERY);
    if (!mql) return undefined;

    const onChange = event => setPrefersReduced(event.matches);

    // Safari below 14 only has the deprecated listener API.
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }

    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return prefersReduced;
};

export default usePrefersReducedMotion;
